<template>
  <div
    v-if="showBanner"
    class="env-mapping-warning text-muted small mb-3"
    role="status"
  >
    <p v-if="unmappedNames.length" class="mb-1">
      Modelos sem mapeamento no .env:
      <span class="text-dark">{{ unmappedNames.join(', ') }}</span>
    </p>
    <p v-if="removedNames.length" class="mb-0">
      Removidos do .env:
      <span class="text-dark">{{ removedNames.join(', ') }}</span>
    </p>
  </div>
</template>

<script>
/**
 * Faixa não bloqueante acima da lista de modelos (notifications.status = 3).
 * Design: notificacoes-design.md § Aviso de mapeamento .env
 */
export default {
  name: 'EnvMappingWarning',
  props: {
    /** AdminModelItem[] sem chave MODELO_* */
    unmappedModels: { type: Array, default: () => [] },
    /**
     * Modelos status=3 que a API marca como removidos do mapa .env
     * (ou mesmo conjunto que unmapped, se a API não distinguir).
     */
    removedFromEnvModels: { type: Array, default: () => [] },
  },
  computed: {
    unmappedNames() {
      return this.namesFrom(this.unmappedModels)
    },
    removedNames() {
      return this.namesFrom(this.removedFromEnvModels)
    },
    showBanner() {
      return this.unmappedNames.length > 0 || this.removedNames.length > 0
    },
  },
  methods: {
    namesFrom(list) {
      if (!Array.isArray(list)) return []
      const names = []
      const seen = {}
      list.forEach((item) => {
        const name =
          (item &&
            (item.title ||
              item.modelName ||
              item.model_name ||
              item.name ||
              item.key)) ||
          null
        if (!name || seen[name]) return
        seen[name] = true
        names.push(name)
      })
      return names
    },
  },
}
</script>

<style scoped>
.env-mapping-warning {
  border-left: 3px solid #b06f16;
  background: #fdf8f0;
  padding: 0.55rem 0.75rem;
  border-radius: 0 0.35rem 0.35rem 0;
  color: #6c757d;
  line-height: 1.35;
}
</style>
